import React, { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "@emotion/styled";

const WrapperAccordian = styled(Accordion)`
  border-radius: 0px !important;
  margin: 20px 0;
  padding: 5px 20px;
  max-width: 100%;
  border:1px solid ${(props) => (props.color ? props.color : props.theme.textPrimary)} !important;
 color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
`;
const Index = () => {
  const [expanded, setExpanded] = useState("false");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div >
      <WrapperAccordian expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon   />} aria-controls="panel1bh-content" id="panel1bh-header" >
          <Typography sx={{ textAlign:"left", textTransfom: "uppercase", width: "100%", flexShrink: 0 }}>
          What is incognito?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{textAlign:"left", width: "100%", flexShrink: 0 }}>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry standard dummy text ever since the 1500s, 
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
     
      <WrapperAccordian expanded={expanded === "panel5"} onChange={handleChange("panel5")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon  />} aria-controls="panel5bh-content" id="panel5bh-header" >
          <Typography sx={{textAlign:"left",  width: "100%", flexShrink: 0 }}>
           Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ textAlign:"left",width: "100%", flexShrink: 0 }}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry standard dummy text ever since the 1500s, 
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
      <WrapperAccordian expanded={expanded === "panel6"} onChange={handleChange("panel6")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon  />} aria-controls="panel6bh-content" id="panel6bh-header" >
          <Typography sx={{textAlign:"left",  width: "100%", flexShrink: 0 }}>
          dummy text of the printing and typesetting industry.Lorem Ipsum has 
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ textAlign:"left",width: "100%", flexShrink: 0 }}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry standard dummy text ever since the 1500s, 
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
      <WrapperAccordian expanded={expanded === "panel7"} onChange={handleChange("panel7")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon  />} aria-controls="panel7bh-content" id="panel7bh-header" >
          <Typography sx={{textAlign:"left",  width: "100%", flexShrink: 0 }}>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ textAlign:"left",width: "100%", flexShrink: 0 }}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry standard dummy text ever since the 1500s, 
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
    </div>
  );
};

export default Index;